import { normalize } from 'normalizr'
import { Schemas } from 'redux/schema'
import { updateEntities } from 'redux/entities'

import api from 'utils/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contentexpress/partFile/FETCH_REQUEST'
const FETCH_SUCCESS = 'contentexpress/partFile/FETCH_SUCCESS'
const FETCH_FAILURE = 'contentexpress/partFile/FETCH_FAILURE'

const CREATE_REQUEST = 'contentexpress/partFile/CREATE_REQUEST'
const CREATE_SUCCESS = 'contentexpress/partFile/CREATE_SUCCESS'
const CREATE_FAILURE = 'contentexpress/partFile/CREATE_FAILURE'

const UPDATE_REQUEST = 'contentexpress/partFile/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contentexpress/partFile/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contentexpress/partFile/UPDATE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  result: {},
  updating: false,
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest() {
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess() {
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []) {
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess() {
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Action Creators
export function loadPartFiles(id, options) {
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/parts/${id}/files`, options)
      .then(({ data }) => {
        const updateData = data?.map((file) => ({
          ...file,
          preview: file?.uri || '',
        }))

        const normalizedJson = normalize(updateData, Schemas.PART_FILE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(updateData))

        return { success: true, data: updateData }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        result: payload,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors,
      }
    default:
      return state
  }
}
